export default __webpack_public_path__ + "static/media/touchThree.8525e0c4.svg";